import { render } from "./CustomerDetails.vue?vue&type=template&id=3cccb6fc"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__